import { render, staticRenderFns } from "./SponsorForm.vue?vue&type=template&id=014c8b78&"
import script from "./SponsorForm.vue?vue&type=script&lang=js&"
export * from "./SponsorForm.vue?vue&type=script&lang=js&"
import style0 from "./SponsorForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports